import * as React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const ForumReputationSvg = React.memo(
    (props: {
        size?: number;
        primaryColor?: string;
        containerStyle?: StyleProp<ViewStyle>;
    }) => {
        const size = props.size ?? 22;
        const width = size;
        const height = (size * (22/22));
// width={size}
//       height={size * (30 / 47)}
//       viewBox="0 0 47 30"
        return (
            <View style={props.containerStyle}>
                <Svg
                    width={width}
                    height={height}
                    viewBox="0 0 22 22"
                    fill="none"
                    {...props}
                >
                    <Path
                        d="M14.108 4.776L15.4 7.361c.174.357.642.697 1.036.77l2.337.385c1.495.247 1.843 1.33.77 2.41l-1.824 1.825c-.302.303-.476.898-.376 1.33l.523 2.254c.413 1.778-.54 2.475-2.108 1.54l-2.191-1.302c-.394-.238-1.054-.238-1.449 0l-2.19 1.302c-1.568.926-2.521.238-2.109-1.54l.523-2.255c.1-.421-.073-1.017-.376-1.329l-1.824-1.824c-1.073-1.073-.724-2.154.77-2.411l2.337-.385c.395-.064.862-.413 1.036-.77l1.293-2.585c.687-1.402 1.824-1.402 2.53 0z"
                        fill={props.primaryColor ?? '#F35E2E'}
                    />
                    <Path
                        opacity={0.4}
                        d="M7.333 4.583h-5.5M4.583 17.416h-2.75M2.75 11h-.917"
                        stroke={props.primaryColor ?? '#F35E2E'}
                        strokeWidth={1.5}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </Svg>
            </View>
        );
    },
);

ForumReputationSvg.displayName = 'ForumReputationSvg';

export { ForumReputationSvg };
